import React from 'react';
import { useBreakpoint } from 'hooks';
import styles from './appointment_book.module.scss';

const MainContainer = ({ children, isMobile, mobileContentHeight }) => {
  const { sm } = useBreakpoint();
  return (
    <>
      <div className={`content animate-panel ${styles.mobileContent}`}>
        <div className="row">
          <div className="col-lg-12">
            <div className={`hpanel ${styles.hpanelNoMargin}`}>
              <div
                className={`panel-body ${styles.flexColumnOnMobile} ${styles.mobileContainer}`}
                style={{
                  height:
                    isMobile && mobileContentHeight && sm
                      ? mobileContentHeight
                      : '',
                }}
              >
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainContainer;
